// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ij-6";
export var imgContainer = "_ij-3";
export var menuIcon = "_ij-5";
export var pillWrapper = "_ij-2";
export var pillsContainer = "_ij-1";
export var subscriptionCard = "_ij-0";
export var subscriptionLogo = "_ij-4";